import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Link } from '@maui/elements'
import withFreemium from '../common/Freemium/WithFreemium'
import { formatMediumDate } from '@/utilities'
import { Definition, Term } from '../common/Details'
import ListExpander from '../common/ListExpander'
import { useAuthContext } from '../../AuthContextProvider'
import { UpgradeIconPill } from '@maui/freemium'

const ReportsIcon = ({ isHidden }) => {
  return (
    isHidden
      ? <Icon name='user-secret' fill='colorActionPrimary' marginRight='10px' visibility='hidden' />
      : <Icon name='user-secret' fill='colorActionPrimary' marginRight='10px' />
  )
}

ReportsIcon.propTypes = {
  isHidden: PropTypes.bool
}

const isMainReport = (reportType, detailType) => reportType && typeof reportType === 'string'
  ? reportType.includes(`${detailType} Overview`) || reportType.includes(`${detailType} Profile`)
  : false

const StyledLink = ({ item }) => (
  <Link
    as='a'
    href={item.url}
    marginLeft='8px'
    color='colorTextMain'
    textDecoration='none' _hover={{ color: 'colorActionPrimary', textDecoration: 'underline' }}
  >
    {item.title || item}
  </Link>
)

StyledLink.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  })
}

const ReportsList = (props) => {
  const { hasAccessToObject } = useAuthContext()
  const { list, type } = props
  const [showReports, setShowReports] = useState(false)
  const reportsArray = showReports ? list : list && list.slice(0, 5)

  return (
    <>
      <Box
        as='ul'
        padding='0'
        margin='0'
        style={{ listStyle: 'none' }}
      >
        {(!reportsArray || !reportsArray.length) && <Box as='li' marginBottom='10px'>No data available</Box>}
        {reportsArray && !!reportsArray.length && reportsArray.map((item, i) => {
          const locked = !hasAccessToObject(item)
          return (
            <Box
              as='li'
              data-testid='reports-list-item'
              display='flex'
              alignItems='flex-start'
              justifyContent='space-between'
              width='100%'
              marginBottom='10px'
              key={i}
            >
              <Box display='flex'>
                <Box as='span' display='inline-block'><ReportsIcon isHidden={!isMainReport(item.reportType, type)}/></Box>
                { locked && <UpgradeIconPill iconSize='sm' variant='icon' mr='spaceGapSmall' mb='spaceGapMedium' /> }
                { !locked && <Box as='span' display='inline-block'> <Icon name='notepad' /> </Box> }
                <StyledLink item={item} />
              </Box>
              {
                item.date
                  ? <Box
                    as='span'
                    textTransform='uppercase'
                    marginLeft='30px'
                    minWidth='200px'
                    textAlign='right'>
                    {formatMediumDate(item.date)}
                  </Box>
                  : null
              }
            </Box>
          )
        })}
      </Box>
      {reportsArray && !!reportsArray.length && list.length > 5 &&
      <ListExpander
        type='Relevant Reports'
        total={list.length}
        expandHandler={() => { setShowReports(!showReports) }}
        expanded={showReports}
      />}
    </>
  )
}

ReportsList.propTypes = {
  list: PropTypes.shape({
    length: PropTypes.number,
    slice: PropTypes.func
  }),
  type: PropTypes.string
}

const ReportsWithFreemium = withFreemium({ prop: 'list', layout: 'fullCenter' })(ReportsList)

/** A Detail List for displaying Relevant Reports
 * @list should be formatted like `[{name: string, url: string, date: string}]`
 */
export const RelevantReportsDetail = (props) => {
  const { list, type } = props
  return (
    <>
      <Term>Relevant Reporting</Term>
      <Definition>
        <ReportsWithFreemium list={list} type={type} />
      </Definition>
    </>
  )
}

RelevantReportsDetail.propTypes = {
  list: PropTypes.array,
  type: PropTypes.string
}

export default RelevantReportsDetail
